export default "__VITE_ASSET__Dd2rqFdX__"